//en.js
export default {
  pc: {
    homepage: {
    },
    aboutus: {
      title: 'About us',
      title1: 'COTE is a Swiss high-end magazine and luxury operator. ',
      desc1: 'For more than 20 years, it has been committed to defining and interpreting “new high-quality lifestyles” based on its role as a Swiss citizen and a contemporary magazine.',
      title2: 'COTE is unique in the luxury world.',
      desc2: 'Its brand mission is to defend the value of citizens and businesses that pursue high-end quality of life in daily life and make this value be fully embodied.',
      title3: 'COTE Concierge',
      desc3: 'is the high-end private concierge service under the COTE brand. We customize thoughtful and meticulous services for both business and private clients based on their unique demands.',
    },
    flagshipservices: {
      title: 'Flagship Services',
      //subtitle: common.coteconcierge
      // titleimageurl: '../../assets/img/cote/mobile/tu-07-compress-fr.png', 

      title1: '1. Employee Services',
      desc1: 'Well-being services for employees (Massages, Hair and Beauty treatments, etc.)Car services (Car-washing, tyre change, etc.)Postal services and personal packages Welcome service (Pastries, fruit baskets, flower, etc.)Security/Bodyguard',
      title2: '2. Business trips',
      desc2: 'Hotel reservationsTransport (Flights, Train tickets, Booking taxis, etc.)Planning and meeting management Personal Assistant Driver',
      title3: '3. Events ',
      desc3: 'Corporate/Institution Events Conference and convention Organization Catering Service Team Building',
      title4: '4. Exclusive Privileges',
      desc4: 'Also, thanks to our privileged network of relationships with many major players in the region’s economy, you will be able to benefit from exclusive experiences: personal assistance during your shopping, visits to watch manufactures and fashion houses, meals with CEOs, private openings of boutiques, VIP seats and private boxes at fashion shows…',

    },

    privateclient: {
      //Private Client 
      title: 'Private&nbspClient',
      desc1: 'Luxury Hotels ',
      desc2: 'Limousine ',
      desc3: 'Private Jet/Yachting ',
      desc4: 'Michelin Restaurant booking ',
      desc5: 'Tailor Made Shopping ',
      desc6: 'Anti-aging/Skin care/Slimming/Beauty clinic/Massage/SPA',
      desc7: 'Real Estate Rental & Deal',
      // desc8: '',
      desc9: 'Family Holiday/Private parties/Birthday', 
      desc10: 'parties planning',
      desc11: 'Housekeeping ',
      desc12: '(Chef/Gardening/Driver/Bodyguard/Family doctor, etc.)',
      desc13: 'Day to Day ',
      desc14: '(Grocery shopping/Postal services/Repair and maintenance/Pet, etc.)',
      desc15: 'Education ',
      desc16: '(Private school/Sports coach/Language study, etc.)',

    },
    contactus: {
      title: 'Contact Us',
      desc: '',
      address: 'Address: ',
      phonenumber: 'Phone number: ',
      email: 'E-mail: ',
      website: 'Website: ',
      officehours: 'Office hours: Monday- Friday 06:00 - 18:00',

      //sub title: common.coteconcierge
      messageboard: {
        firstname: 'First Name*',
        lastname: 'Last Name*',
        email: 'Email*',
        phonenumber: 'Phone Number',
        messagecontent: 'Message*',
        send: 'Send',
        length_errmsg:  'No more than {count} characters.',
        //调用的地方：$tc('length_errmsg', x)
        firstname_errmsg: 'Please input your first name.',
        lastname_errmsg: 'Please input your last name.',
        email_errmsg: 'Please input your email. ',
        email_errmsg2: 'The email format is wrong.',
        phonenumber_errmsg: '',
        messagecontent_errmsg: 'Please input a message.',
        // $tc('length_errmsg', 1000)
        messagecontent_errmsg2: 'The message should not exceed {count} words, please check.',
        send_errmsg: 'Message board submission failed, please check the input information and try again.',
        send_errmsgwithdetails: 'Message board submission failed, please check the input information and try again. Error details:{details}',
        //$tc('send_errmsgwithdetails', errordetails)
        send_errmsg2: 'Message board submission failed due to system error, please contact the administrator to check.',
        send_sucessmsg: 'Message board submitted successfully. Thank you!',
      },
    },
    common: {
      coteconcierge: 'Cote Concierge',
      services: 'Services',
      contact: 'Contact',
    },
  }
}